import tw, { styled } from 'twin.macro'

const Slogan = styled.p(({ variant }) => [
  // The common button styles added with the tw import
  tw`text-[72px] leading-tight pb-[200px] lg:pb-[120px] xl:text-[56px] md:text-[32px]`,

])

export default Slogan
